import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

/** Import layout auto */
const requireComponent = require.context(
  '@/components/layouts', true, /[\w-]+-layout\.vue$/
)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//g, '').replace(/\.\w+$/, '').replace(/\//g, '-'))
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})



// WEBPACK FOOTER //
// ./src/plugins/layouts.js